import { axios } from "@/services/axios";
import { merge,has,extend,} from "lodash";
import { currentUser } from "@/services/auth";
// backwards compatibility
const normalizeCondition = {
  "greater than": ">",
  "less than": "<",
  equals: "=",
};

const transformResponse = data =>
  merge({}, data, {
    options: {
      op: normalizeCondition[data.options.op] || data.options.op,
    },
    query: data.query || {},
    destinations: data.destinations || [],
    tags: data.tags || [],
    user: data.user || currentUser,

  });

  const transformRequest = data => {
    const newData = Object.assign({}, data);
    if (newData.query_id === undefined) {
      newData.query_id = newData.query.id;
      newData.destination_id = newData.destinations;
      delete newData.query;
      delete newData.destinations;
      delete newData.is_favorite;
    }
    
    return newData;
  };

export class Alert {
  constructor(alert) {
    extend(this, alert);

    if (!has(this, "options")) {
      this.options = {};
    }
    if (!has(this, "query")) {
      this.query = {};
    }
    if (!has(this, "destinations")) {
      this.destinations = [];
    }
    if (!has(this, "tags")) {
      this.tags = [];
    }
    if (!has(this, "user")) {
      this.user = currentUser;
    }

  }

  isNew() {
    return this.id === undefined;
  }

  getUrl() {
    return `alerts/${this.id}`;
  }

  favorite() {
    return Alert.favorite(this.id);
  }

  unfavorite() {
    return Alert.unfavorite(this.id);
  }

}
const saveOrCreateUrl = data => (data.id ? `api/alerts/${data.id}` : "api/alerts");


const AlertService = {
  query: params => axios.get("api/alerts", { params }),
  get: ({ id }) => axios.get(`api/alerts/${id}`).then(transformResponse),
  delete: id => axios.delete(`api/alerts/${id}`),
  recent: params => axios.get("api/alerts/recent", { params }),
  archive: params => axios.get("api/alerts/archive", { params }),
  myAlerts: params => axios.get("api/alerts/my", { params }),
  favorites: params => axios.get("api/alerts/favorites", { params }),
  favorite:  id => axios.post(`api/alerts/${id}/favorite`),
  unfavorite: id => axios.delete(`api/alerts/${id}/favorite`),
  mute: data => axios.post(`api/alerts/${data.id}/mute`),
  unmute: data => axios.delete(`api/alerts/${data.id}/mute`),
};

AlertService.save = data => axios.post(saveOrCreateUrl(data), transformRequest(data)).then(transformResponse);

AlertService.newAlert = function newAlert() {
  return new Alert({
    name: "New Alert",
    query: null,
    options: {
      op: ">",
      column: null,
      value: 0,
    },
    destinations: [],
    user: currentUser,
    tags: [],
    can_edit: true,
    rearm: 0,
  });
}

extend(Alert, AlertService);

export default Alert;
